import PropTypes from "prop-types";
import React from "react";

import { fireTrack } from "@swa-ui/analytics";
import { useDeviceInfo, XLARGE } from "@swa-ui/browser";
import { Card, ListMatrix, ListScroller } from "@swa-ui/core";
import i18n from "@swa-ui/locale";
import { PlacementFactory } from "@swa-ui/placements";
import { classNames } from "@swa-ui/string";

import styles from "./LuvStoryCard.module.scss";

const PLACEMENT_COUNT = 3;

export const LuvStoryCard = (props) => {
  const { placementIds, placementData } = props;
  const { isSmallOrMedium, screenSize } = useDeviceInfo();

  return renderLuvStories();

  function renderLuvStories() {
    let component;

    if (placementIds.length > PLACEMENT_COUNT) {
      component = renderListScroller();
    } else if (placementIds.length > 0 && placementIds.length <= PLACEMENT_COUNT) {
      component = isSmallOrMedium ? renderListScroller() : renderListMatrix();
    }

    return component;
  }

  function renderListMatrix() {
    return <ListMatrix {...getListMatrixProps()} />;
  }

  function renderListScroller() {
    return <ListScroller {...getListScrollerProps()} />;
  }

  function renderLuvStoryPlacement(placementId) {
    return (
      <Card {...getCardProps()}>
        <PlacementFactory className={styles.luvStoryPlacementContainer} id={placementId} />
      </Card>
    );
  }

  function getCardProps() {
    return {
      className: styles.cardContainer,
      fullHeight: true,
      fullHeightContent: true,
      fullWidthContent: true,
    };
  }

  function getListMatrixProps() {
    return {
      items: placementIds.map((placementId) => ({
        content: renderLuvStoryPlacement(placementId),
      })),
      numberOfColumns: placementIds.length,
      rowClassName: styles.listRow,
    };
  }

  function getListScrollerProps() {
    return {
      "aria-label-current-page": i18n("LuvStoryCard__ARIA_LABEL_CURRENT_PAGE"),
      "aria-label-focus-change-next": i18n("LuvStoryCard__ARIA_LABEL_FOCUS_CHANGE_NEXT"),
      "aria-label-focus-change-previous": i18n("LuvStoryCard__ARIA_LABEL_FOCUS_CHANGE_PREVIOUS"),
      "aria-label-next": i18n("LuvStoryCard__ARIA_LABEL_NEXT"),
      "aria-label-page-count": i18n("LuvStoryCard__ARIA_LABEL_PAGE_COUNT"),
      "aria-label-previous": i18n("LuvStoryCard__ARIA_LABEL_PREVIOUS"),
      className: classNames({ [styles.center]: screenSize === XLARGE }),
      itemClassName: styles.item,
      items: placementIds.map((placementId) => renderLuvStoryPlacement(placementId)),
      numberOfColumns: isSmallOrMedium ? 2 : 3,
      onClick: handleClick,
      showPositionIndicator: !isSmallOrMedium,
    };
  }

  function handleClick() {
    const analyticsValue = placementData?.analyticsValue;

    analyticsValue && fireTrack("squid", { page_description: analyticsValue });
  }
};

LuvStoryCard.displayName = "LuvStoryCard";
LuvStoryCard.propTypes = {
  /** Additional data to pass to the placement */
  placementData: PropTypes.object,

  /** Array of placement id's. */
  placementIds: PropTypes.array.isRequired,
};
